import { render, staticRenderFns } from "./health_suggestion.vue?vue&type=template&id=ef7cf4f6&scoped=true&"
import script from "./health_suggestion.vue?vue&type=script&lang=js&"
export * from "./health_suggestion.vue?vue&type=script&lang=js&"
import style0 from "./health_suggestion.vue?vue&type=style&index=0&id=ef7cf4f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7cf4f6",
  null
  
)

export default component.exports